import { PRE_REGISTRATION_API_URL } from "../config/apiConfig";

const API_BASE_URL = PRE_REGISTRATION_API_URL;

export const endpoints = {
    hero: `${API_BASE_URL}/representant/hero-registration`,
    company: `${API_BASE_URL}/representant/company-registration`,
    nonCompany: `${API_BASE_URL}/representant/regular-registration`,
    geoInfo: `${API_BASE_URL}/representant/ipinfo`,
};